import React, { memo, useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { SettingsItemCard } from 'design-system';
import ProgressBar from 'design-system/ProgressBar';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { IconMedal } from 'design-system/icons/IconMedal';
import { selectQuestsSummary } from 'features/quests/store/selectors';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const strings = {
    introduction: 'Unlock them all to become a pro',
    fromTotal: 'from 100%',
};
const QuestsCard = () => {
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const { percentage } = useAppSelector(selectQuestsSummary);
    const onPress = useCallback(() => {
        navigation.navigateDeprecated('Quests', { source: 'settings' });
    }, []);
    return (<SettingsItemCard icon={<IconMedal gradientKey="ultimate" height={24} width={24}/>} title="Quests" description={percentage === 0 ? (strings.introduction) : (<View style={styles.progress}>
            <ProgressBar position={percentage} colors={colors.gradients.ultimate.colors}/>
            <Text TextThin-14 Secondary>
              {`${percentage}% ${strings.fromTotal}`}
            </Text>
          </View>)} onPress={onPress} testID="settings-quests-card"/>);
};
const styles = StyleSheet.create({
    progress: {
        gap: rem(8),
        marginTop: rem(4),
    },
});
export default memo(QuestsCard);
